import { DesktopLegacySessionApiService } from 'api/legacy-session/desktop-legacy-session.api.service';

import { LegacySessionService } from 'api/legacy-session/interfaces';

const LegacySessionApiService = DesktopLegacySessionApiService;

const legacySessionApiService: LegacySessionService =
  new LegacySessionApiService();

export { legacySessionApiService };
